export default __webpack_public_path__ + "static/media/Future.f8e10b23.svg";